
const ConfigError = ({ errors }) => (
  <div className="w-full h-screen bg-[#f2f4f7] flex items-center justify-center p-6">
    <div className="max-w-xl w-full bg-white border border-[#dfe4ed] rounded-lg p-6">
      <div className="flex items-center gap-2">
        <span className="material-icons text-2xl text-[#d92d20]">settings_alert</span>
        <span className="text-sm font-medium text-[#272d37]">Configuration error</span>
      </div>
      <span className="mt-2 block text-sm font-normal text-[#616a79]">
        This build is missing required environment variables, so it cannot reach
        the API or the platform. Env values are baked in at build time — setting
        them requires a rebuild and redeploy.
      </span>
      <div className="mt-4 flex flex-col gap-2">
        {errors.map(({ name, purpose }) => (
          <div key={name} className="bg-[#f9fafa] border border-[#dfe4ed] rounded-md px-3 py-2">
            <span className="block text-sm font-medium text-[#272d37]">{name}</span>
            <span className="block text-xs font-normal text-[#616a79]">{purpose}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default ConfigError
